import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 56322 55493"
    {...props}
  >
    <path
      d="M37183 33277c1974 750 4559 2142 7817 4138-3265-2000-5694-3674-7280-5097 1861-2071 7672-2060 17797-585-10056-1466-15569-3112-16668-5629 1956-678 4768-1251 8461-1789-3702 540-6575 797-8666 716 97-2788 4660-6556 13573-12012-8859 5424-14250 7744-16717 6513 1027-1761 2755-3984 5160-6736-2409 2757-4384 4776-5998 6045-1698-2207-517-8064 3000-18036-3508 9948-6258 15233-8960 15857-382-1996-541-4789-541-8416 0 3627-160 6420-542 8416-2702-624-5451-5909-8960-15857 3517 9972 4699 15829 3000 18036-1614-1269-3589-3289-5997-6045 2404 2752 4132 4975 5159 6736-2467 1231-7858-1089-16717-6513 8913 5456 13477 9224 13573 12012-2091 82-4964-176-8665-716 3693 538 6505 1111 8461 1789-1099 2516-6613 4163-16668 5629 10125-1475 15936-1486 17797 585-1586 1423-4015 3098-7280 5097 3258-1995 5844-3387 7817-4138 789 2630-2269 7397-8834 14912 6594-7548 10929-11255 13674-10881-337 2125-1176 4992-2467 8656 1290-3660 2434-6414 3503-8271 2318 1489 3148 7073 3148 16996 0-9923 828-15506 3146-16996 1069 1857 2212 4611 3503 8271-1292-3664-2132-6531-2469-8656 2746-374 7081 3333 13674 10881-6565-7515-9624-12282-8834-14912z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 1609.2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
